import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import MainLayout from "./components/layout/MainLayout";
import Landing from "./pages/landing/Landing";
import EquipmentPage from "./pages/equipments/EquipmentPage";
import EquipmentDetails from "./pages/equipments/EquipmentDetails";
import ContactUs from "./pages/contact/ContactUs";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DiscoverUs from "./pages/discover-us/DiscoverUs";




const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
};


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />} >
          <Route path="/" element={<Landing />} />
          <Route path="/discover" element={<DiscoverUs />} />
          {/* <Route path="/services" element={<ServicePage />} /> */}
          <Route path="/equipments" element={<EquipmentPage />} />
          <Route path="/equipments/:id" element={<EquipmentDetails />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
